
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spaces",
      function () {
        return require("private-next-pages/spaces/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spaces"])
      });
    }
  